import React, { Fragment, useRef } from "react";
import "../../../Assets/Styles/Modal.css";
import arrow from "../../../Assets/Images/Icons/right-arrow.png";
import { toast } from "react-toastify";
import emailjs from "@emailjs/browser";

const RequestAQuoteModal = ({ setModal }) => {
  const form = useRef();
  // console.log(form.current);
  const sendEmail = (e) => {
    e.preventDefault();
    console.log(e.target);
    emailjs
      .sendForm(
        "service_dlf4p59",
        "template_8kdfgl7",
        form.current,
        "R6Z8PkwQuMqQSNzFV"
      )
      .then(
        (result) => {
          if (result) {
            toast.success("Thank you, I will reply you within 24 hours!");
            setModal(false);
          }
        },
        (error) => {
          if (error) {
            toast.warn("Sorry, try again !");
            setModal(false);
          }
        }
      );
    e.target.reset();
  };

  return (
    <Fragment>
      <section className="modal">
        <div className="bg-[#fff] p-5 max-sm:px-[40px] max-sm:py-[40px] max-sm:max-w-[500px] requestAQuoteModal">
          <h2 className="font-bold font-fira text-3xl text-linear-gradient mb-10">
            Request A Quote
          </h2>

          <form ref={form} onSubmit={sendEmail}>
            <input
              type="text"
              name="company_name"
              placeholder="Company Name"
              required
            />
            <input type="text" name="phone" placeholder="Phone" required />
            <input type="Email" name="email" placeholder="Email" required />
            <textarea name="message" id="" placeholder="Message..."></textarea>
            <button className="custom_button flex justify-center items-center">
              Send
              <img className="ml-2" src={arrow} alt="Global IT Master" />{" "}
            </button>
          </form>
          <button
            onClick={() => setModal(false)}
            className="Modal_close_btn text-primary"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
      </section>
    </Fragment>
  );
};

export default RequestAQuoteModal;
